import validationMessagesTemplate from './util/validation-messages.html';
import tourStepTemplate from './util/tour-step-template.html';
import get from 'lodash/get';
import '@fontsource/roboto/latin.css';
import '@fontsource/roboto/latin-ext.css';

export default scrRun;

/** @ngInject */
function scrRun($rootScope, $log, $templateCache, $transitions, $mdDialog, $window, $http) {
  $rootScope.me = {
    schoolCommonRoomId: 0,
    name: ''
  };

  $templateCache.put('error-messages', validationMessagesTemplate);
  $templateCache.put('tour-step-template', tourStepTemplate);

  $transitions.onSuccess({to: state => {
    return angular.isDefined(state.data) && angular.isDefined(state.data.hideNavbar) && state.data.hideNavbar === true;
  }}, () => {
    $rootScope.$broadcast('layout.header.hide');
  });

  $transitions.onEnter({to: state => {
    if (state.name === 'modules.dashboard') {
      $rootScope.$broadcast('state.dashboard');
    }

    return angular.isUndefined(state.data) || angular.isUndefined(state.data.hideNavbar);
  }}, () => {
    $rootScope.$broadcast('layout.header.show');
  });

  $transitions.onError({}, transition => {
    const error = transition.error();
    if (angular.isDefined(get(error, 'MessagePL'))) {
      $mdDialog.show(
        $mdDialog.extendError({
          locals: {error}
        })
      );
    }
  });

  $window.addEventListener('afterprint', () => {
    const originAddress = $window.location.origin;
    $http({
      method: 'POST',
      url: `${originAddress}/gateway/api/2.0/PersonalDataAccesses`,
      data: {
        description: 'wykonano wydruk danych z przeglądarki w Świetlicy'
      }
    });
  });
}
